// main Import
import React, {useState,useEffect} from "react";

// Custom Css
// import "./executiveDash.css";
import Colors from '../../Global/colors'
import { Chart as  GoogleChart } from "react-google-charts";

// Material UI Components
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import calander from "../../Assets/due_inspection.png";
import Table from '@material-ui/core/Table';
import GlobalApi from "../../Global";
import refresh_token from "../../Global/refresh_token";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Dialog from "@material-ui/core/Dialog";
import Chart from "react-apexcharts";
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Spinner from "../../Global/Spinner2";
import {useTranslation} from 'react-i18next';


//Images
import up from '../../Assets/UpG.png'
import dots from '../../Assets/dots.png'
import down from '../../Assets/DownG.png'
import NoRecord from '../../Assets/no_records.png'


//Redux
import { useSelector, useDispatch } from "react-redux";




function createData(area, current, previous, trend) {
    return { area, current, previous, trend};
  }

const rows = [
  createData("Area 1", 19, 6),
  createData("Area 2", 87, 90),
  createData("Area 3", 10, 16),
  createData("Area 4", 62, 16),
];

function createData1(question,Score) {
  return {question,Score};
}
function createData2(question,score,total) {
  return {question,score,total};
}

function createData3(inspection,score,aging,inspector) {
  return {inspection,score,aging,inspector};
}

const rows1 = [
createData1("Question1", 19),
createData1("Question2", 87),
createData1("Question3", 10),
createData1("Question4", 62),
createData1("Question5", 19),
createData1("Question6", 87),
createData1("Question7", 10),
createData1("Question8", 62),
];

const rows2 = [
createData1("Question1", 19.5),
createData1("Question2", 87.5),
createData1("Question3", 10.5),
createData1("Question4", 62.7),
createData1("Question5", 19.5),
createData1("Question6", 87.8),
createData1("Question7", 10.1),
createData1("Question8", 62.5),
];

const rows3 = [
  createData2("Question1", 5 ,12),
  createData2("Question2", 2 ,17),
  createData2("Question3", 7 ,20),
  createData2("Question4", 12 ,58),
  createData2("Question5", 12 ,30),
  createData2("Question6", 18 ,22),
  createData2("Question7", 5 ,8),
  createData2("Question8", 12 ,12),
  ];

  const rows4 = [
    createData3("Area 1", 19, 6, "mark"),
    createData3("Area 2", 87, 90, 'joe'),
    createData3("Area 3", 10, 16,'tom'),
    createData3("Area 4", 62, 16,'tim'),
    createData3("Area 1", 19, 6, 'sam'),
    createData3("Area 2", 87, 90,'lex'),
    createData3("Area 3", 10, 16,'nofe'),
    createData3("Area 4", 62, 16,'samel'),
  ];



const useStyles = makeStyles((theme) => ({

  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  container: {
    maxHeight: "270px",
  },
}));

function ExecutiveDashboard({
  frequentlyFailed,
  frequentlyFailedLoader,
  lowestScoring,
  lowestScoringLoader,
  mostFailed,
  mostFailedLoader,
  lowestcompletion,
  lowestcompletionLoader,
  responseData,
  responseDataLoader,
  companyID,
  to,
  from,
}) {
  const {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const [responses, setResponses] = useState([]);
  const [currentResponses, setCurrentResponses] = useState([]);



  const selectResponse = (e) => {
    console.log("current Response ID ", e.target.value);
    console.log("companyID ", companyID ? companyID : company.id);
    console.log("To Date ", to);
    console.log("From Date ", from);


    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      response_id: e.target.value,
      from_date: from,
      to_date: to,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Dashboard/on_response_changes?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("DATA FROM Second Api", response);
        if (response.msg === "success") {
          
          let data = [];
          let total = 0;
          response.data.forEach((item) => {
            total = total + parseInt(item.count);
          });

          console.log("TOTAL COUNT ", total);
          let newRes = [["complete", "incomplete"]];
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              newRes.push([item.title, parseInt(item.count)]);
              data.push({ title: item.title, score: parseInt(item.count) });
            });
          }

          console.log(newRes);
          setCurrentResponses(data);
          setResponses(newRes);
          // if (isNaN(response.plannedToActualRatio)) {
          //   setPlannedToActual(0);
          // } else {
          //   setPlannedToActual(response.plannedToActualRatio);
          // }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            selectResponse();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const classes = useStyles();

  return <Grid container spacing={0} style={{ justifyContent: "space-between", flexDirection: "column", backgroundColor: Colors.globalColor9,marginTop: "0px", boxShadow: "none" }} justifyContent="space-between" className="fliterBox" >
      {/* ================================== Section 3 Begins =================================== */}
      <Grid item xs={12} justifyContent="center" alignItems="center">
        <div style={{ width: "100%", padding: "10px", backgroundColor: "white" }}>
          {/* <Grid container spacing={2} justifyContent="center" alignItems="center" className="fliterBox" style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px", boxShadow: "none" }}>
            <Grid item xs={12} md={6} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
              <div style={{ width: "100%", minHeight: "200px", borderRadius: "10px", border: "1px solid #dadada", backgroundColor: Colors.globalColor9, display: "flex", overflow: "hidden" }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                  <Grid item xs={12} md={6} lg={6} justifyContent="flex-start" alignItems="center">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div style={{ flex: "2" }}>
                        <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), color: Colors.globalColor8, margin: "5px" }}>
                          Response Breakdown
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title="Find out the most habituated responses by the inspector during the inspection period in a given time frame. It is represented by a pi-chart with a built-in response set including yes, no, or not applicable.">
                          <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                    {responseDataLoader ? <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        <Spinner />
                      </div> : <Select className="SelectBox" style={{ width: 170 }} variant="outlined" size="small" onChange={(e) => selectResponse(e)}>
                        {responseData.length > 0 && responseData.map(
                            (item, index) => {
                              return (
                                <MenuItem value={item.id}>
                                  {item.response_details_title}
                                </MenuItem>
                              );
                            }
                          )}
                        {responseData.length == 0 && <div style={{ padding: "0px 10px" }}>
                            <p>No Records</p>
                          </div>}
                      </Select>}

                    <div className="scrollHidden" style={{ height: "100px", overflow: "auto" }}>
                      {currentResponses.length > 0 && currentResponses.map(
                          (item, index) => {
                            return (
                              <div style={{ display: "flex", margin: "2px" }}>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    margin: "2px",
                                  }}
                                >
                                  {item.title + "  :  " + item.score}
                                </p>
                              </div>
                            );
                          }
                        )}
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                    <div style={{ width: "100%", height: "100%" }}>
                      {responses.length > 0 && (
                        <GoogleChart
                          chartType="PieChart"
                          loader={<div>Loading Chart</div>}
                          data={responses}
                          options={{
                            colors: [
                              "#16234d",
                              "#2a428c",
                              "#3657b6",
                              "#4c78d9",
                              "#639df1",
                              "#8ecefc",
                              "#aee8fe",
                              "#d8f9ff",
                              "#f2fdff",
                            ],
                            backgroundColor: "transparent",
                            width: 150,
                            height: 150,
                            chartArea: { width: "100%", height: "80%" },
                            legend: { position: "none" },
                            pieHole: 0,
                          }}
                          rootProps={{ "data-testid": "3" }}
                        />
                      )}
                      {responses.length == 0 && <div style={{display:"flex", justifyContent:'center', alignItems:"center"}}><img src={NoRecord} width={"200px"} alt="no Record" /></div>}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid> */}

          <Grid container spacing={2} justifyContent="space-between" alignItems="center" className="fliterBox" style={{ padding: "5px", boxShadow: "none" }}>
            <Grid item xs={12} lg={6} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", padding: "10px", border: "1px solid #dadada", height: "280px", overflow:'hidden' }}>
                <div style={{ padding: "5px 5px 5px 5px", border: "1px solid #dadada" }}>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ flex: "2" }}>
                      <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), color: Colors.globalColor8, margin: "5px" }}>
                        {t("Frequently Failed Checklists")}
                      </p>
                    </div>
                    <div style={{ flex: "1", textAlign: "right" }}>
                      <Tooltip title={t("Finds the frequency of most failed items in a specific time to generate counter solutions and enhance the overall business performance.")}>
                        <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                {frequentlyFailedLoader ? <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <Spinner />
                  </div> : <>
                    {frequentlyFailed.length == 0 && <div style={{ display: "flex", border: "1px solid #dadada", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>
            
                              <TableCell style={{backgroundColor:'#f2f2f2', width: "75%", padding: "10px" }}>
                                {" "}
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                                  {t("Checklists")}
                                </p>
                              </TableCell>
                              <TableCell align="center" style={{backgroundColor:'#f2f2f2', width: "25%", padding: "10px",borderRight:"1px solid #dadada" }}>
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                                  {t("Failed")}
                                </p>
                              </TableCell>
                           
                      </div>}

                    {frequentlyFailed.length > 0 && <TableContainer style={{ width: "100%", border: "1px solid #dadada", maxHeight: "200px", overflowY: "auto" }} className={classes.container}>
                        <Table stickyHeader aria-label="sticky table" style={{ width: "100%" }}>
                          <TableHead style={{ width: "100%" }}>
                            <TableRow>
                              <TableCell style={{backgroundColor:'#f2f2f2', width: "75%", padding: "10px" }}>
                                {" "}
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                                  {t("Checklists")}
                                </p>
                              </TableCell>
                              <TableCell align="center" style={{backgroundColor:'#f2f2f2', width: "25%", padding: "10px",borderRight:"1px solid #dadada" }}>
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                                  {t("Failed")}
                                </p>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {frequentlyFailed.map((row) => (
                              <TableRow key={row.name}>
                                <TableCell style={{padding:"10px"}}>
                                {row.title}

                                  <Tooltip title={row.title ? row.title : " " }>
                             <p>
                           {row.title.slice(0, 20) + (row.title.length > 20 ? "..." : "")}
                           </p>
                           </Tooltip>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{borderRight:"1px solid #dadada", padding:"10px"}}
                              
                                >
                                  {row.count}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>}
                  </>}
              </div>
            </Grid>
            <Grid item xs={12} lg={6} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", padding: "10px", border: "1px solid #dadada", height: "280px", overflow:'hidden' }}>
                <div style={{ padding: "5px 5px 5px 5px", border: "1px solid #dadada" }}>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ flex: "2" }}>
                      <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), color: Colors.globalColor8, margin: "5px" }}>
                        {t("Inspection with most failed responses")}
                      </p>
                    </div>
                    <div style={{ flex: "1", textAlign: "right" }}>
                      <Tooltip title={t("The analysis aggregates inspections responses to uncover failed items.")}>
                        <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                {mostFailedLoader ? <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <Spinner />
                  </div> : <>
                    {mostFailed.length == 0 && <div style={{ display: "flex", border: "1px solid #dadada", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>
    
                              <TableCell style={{ width: window.innerWidth > 500 ? "75%" : "50%", padding: "10px", backgroundColor:'#f2f2f2' }}>
                                {" "}
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                                  {t("Inspection")}
                                </p>
                              </TableCell>
                              <TableCell align="center" style={{ width: window.innerWidth > 500 ? "25%" : "50%", padding: "10px", backgroundColor:'#f2f2f2', borderRight:'1px solid #dadada' }}>
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                                  {t("Responses")}
                                </p>
                              </TableCell>
                         
                      </div>}

                    {mostFailed.length > 0 && <TableContainer style={{ width: "100%", border: "1px solid #dadada", maxHeight: "200px", overflowY: "auto" }} className={classes.container}>
                        <Table stickyHeader aria-label="sticky table" style={{ width: "100%" }}>
                          <TableHead style={{ width: "100%" }}>
                            <TableRow>
                              <TableCell style={{ width:window.innerWidth > 500 ? "75%" : "50%", padding: "10px", backgroundColor:'#f2f2f2' }}>
                                {" "}
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                                  {t("Inspection")}
                                </p>
                              </TableCell>
                              <TableCell align="center" style={{ width:window.innerWidth > 500 ? "25%" : "50%", padding: "10px", backgroundColor:'#f2f2f2', borderRight:'1px solid #dadada' }}>
                                <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                                  {t("Responses")}
                                </p>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {mostFailed.map((row) => <TableRow key={row.name}>
                                <TableCell component="th" scope="row" style={{ width: "25%", padding:"10px" }}>
                                  {row.title}
                                </TableCell>
                                <TableCell align="center" style={{ width: "25%",borderRight:"1px solid #dadada", padding:"10px" }}>
                                  {row.failed + "/" + row.total}
                                </TableCell>
                              </TableRow>)}
                          </TableBody>
                        </Table>
                      </TableContainer>}
                  </>}
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="space-between" alignItems="center" className="fliterBox" style={{ padding: "5px", boxShadow: "none" }}>
            <Grid item xs={12} lg={6} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", padding: "10px", border: "1px solid #dadada", height: "280px" , overflow:'hidden' }}>
                <div style={{ padding: "5px 5px 5px 5px", border: "1px solid #dadada" }}>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ flex: "2" }}>
                      <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), color: Colors.globalColor8, margin: "5px" }}>
                        {t("Lowest Scoring Inspection")}
                      </p>
                    </div>
                    <div style={{ flex: "1", textAlign: "right" }}>
                      <Tooltip title={t("Lists inspections with overall weights less than 85%.")}>
                        <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                {lowestScoringLoader ? <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <Spinner />
                  </div> : <>{lowestScoring.length == 0 && <div style={{ display: "flex", border: "1px solid #dadada", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>

                          <TableCell style={{ width: window.innerWidth > 500 ? "75%" : "50%", padding: "10px", backgroundColor:"#f2f2f2" }}>
                            {" "}
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                              {t("Inspection")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{ width: window.innerWidth > 500 ? "25%" : "50%", padding: "10px",backgroundColor:"#f2f2f2",borderRight:'1px solid #dadada' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Score Average")}
                            </p>
                          </TableCell>
                      
                      </div>}

                {lowestScoring.length > 0 && <TableContainer style={{ width: "100%", border: "1px solid #dadada", maxHeight: "200px", overflowY: "auto" }} className={classes.container}>
                    <Table stickyHeader aria-label="sticky table" style={{ width: "100%" }}>
                      <TableHead style={{ width: "100%" }}>
                        <TableRow>
                          <TableCell style={{ width: "75%", padding: "10px", backgroundColor:"#f2f2f2" }}>
                            {" "}
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                              {t("Inspection")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{ width: "25%", padding: "10px",backgroundColor:"#f2f2f2",borderRight:'1px solid #dadada' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Score Average")}
                            </p>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {lowestScoring.map((row) => <TableRow key={row.name}>
                            <TableCell component="th" scope="row" style={{ width: "25%", padding:'10px' }}>
                              {row.title}
                            </TableCell>
                            <TableCell align="center" style={{ width: "25%", padding: "10px", borderRight:'1px solid #dadada' }}>
                              {row.weight}%
                            </TableCell>
                          </TableRow>)}
                      </TableBody>
                    </Table>
                  </TableContainer>}</> }


                
              </div>
            </Grid>
            <Grid item xs={12} lg={6} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", padding: "10px", border: "1px solid #dadada", height: "280px", overflow:'hidden' }}>
                <div style={{ padding: "5px 5px 5px 5px", border: "1px solid #dadada" }}>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ flex: "2" }}>
                      <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), color: Colors.globalColor8, margin: "5px" }}>
                        {t("Lowest Completion Inspection")}
                      </p>
                    </div>
                    <div style={{ flex: "1", textAlign: "right" }}>
                      <Tooltip title={t("Lists inspections with completion score less than 85%.")}>
                        <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                {lowestcompletionLoader ? <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <Spinner />
                  </div> : <>{lowestcompletion.length == 0 && <div style={{ display: "flex", border: "1px solid #dadada", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>

                          <TableCell style={{ width: "25%", padding: "10px", backgroundColor:'#f2f2f2' }}>
                            {" "}
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                              {t("Inspection")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{ width: "25%", padding: "10px",backgroundColor:'#f2f2f2' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Score")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{width: "25%", padding: "10px" , backgroundColor:'#f2f2f2' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Aging")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{width: "25%", padding: "10px", backgroundColor:'#f2f2f2', borderRight:'1px solid #dadada' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Inspector")}
                            </p>
                          </TableCell>
                      </div>}

                {lowestcompletion.length > 0 && <TableContainer style={{ width: "100%", border: "1px solid #dadada", maxHeight: "200px", overflowY: "auto" }} className={classes.conmtainer}>
                    <Table stickyHeader aria-label="sticky table" style={{ width: "100%" }}>
                      <TableHead style={{ width: "100%" }}>
                        <TableRow>
                          <TableCell style={{ padding: "10px", backgroundColor:'#f2f2f2' }}>
                            {" "}
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: (language == "ar" ? "right" : "left"), fontSize: "14px" }}>
                              {t("Inspection")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{ padding: "10px",backgroundColor:'#f2f2f2' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Score")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{ padding: "10px" , backgroundColor:'#f2f2f2' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Aging")}
                            </p>
                          </TableCell>
                          <TableCell align="center" style={{ padding: "10px", backgroundColor:'#f2f2f2', borderRight:'1px solid #dadada' }}>
                            <p className="filterText1" style={{ lineHeight: "1", marginTop: "2px", marginBottom: "2px", textAlign: "center", fontSize: "14px" }}>
                              {t("Inspector")}
                            </p>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {lowestcompletion.map((row) => (
                          <TableRow key={row.name}>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{padding: "10px"}}
                            >
                              {row.title}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{  padding: "10px" }}
                            >
                              {row.score} %
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{padding: "10px" }}
                            >
                              {row.aging}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{borderRight:'1px solid #dadada', padding: "10px" }}
                            >
                              {row.inspector}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>}</>}

                
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/* ================================== Section 3 Ends =================================== */}
    </Grid>;

  {
    /* ================================== Main Area Begins =================================== */
  }

  {
    /* ================================== Filter Bar Begins =================================== */
  }
  {
    /* 
        <Grid container spacing={1} style={{ justifyContent: "space-between" }} justifyContent="space-between" alignItems="center" className="fliterBox" style={{ padding: "5px" }}>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), color: Colors.globalColor8 }}>
              Search & Filters
            </p>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" placeholder="select Company" variant="outlined" size="small">
              <MenuItem value="">Select Company</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" variant="outlined" size="small">
              <MenuItem value="">Select Template</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" variant="outlined" size="small">
              <MenuItem value="">Select Site</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" variant="outlined" size="small">
              <MenuItem value="">Select Inspector</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center" style={{ minWidth: "150px" }}>
            <Grid container spacing={1}>
              <Grid item>
                <img src={calander} width={35} />
              </Grid>
              <Grid item>
                <Grid container style={{ display: "flex", flexDirection: "column" }}>
                  <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), display: "inline-block", fontSize: "10px", marginTop: 0, marginBottom: 0 }}>
                    From
                  </p>
                  <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), fontSize: "10px", display: "inline-block", marginTop: 0, marginBottom: 0 }}>
                    11/12/2022
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center" style={{ minWidth: "150px", display: "flex", justifyContent: "center", textAlign: "center" }}>
            <Grid container spacing={1}>
              <Grid item>
                <img src={calander} width={35} />
              </Grid>
              <Grid item>
                <Grid container style={{ display: "flex", flexDirection: "column" }}>
                  <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), display: "inline-block", fontSize: "10px", marginTop: 0, marginBottom: 0 }}>
                    To
                  </p>
                  <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), fontSize: "10px", display: "inline-block", marginTop: 0, marginBottom: 0 }}>
                    11/12/2022
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Button variant="contained" style={{ backgroundColor: Colors.globalColor8 }}>
              <p className="filterText1" style={{ textAlign: (language == "ar" ? "right" : "left"), color: "white", marginTop: 0, marginBottom: 0 }}>
                Apply
              </p>
            </Button>
          </Grid>
        </Grid> */
  }
  {
    /* ================================== Filter Bar Ends =================================== */
  }
}

export default ExecutiveDashboard;
